import React, { useContext, useEffect, useState } from 'react';
import LogoHeader from '../Componentes/LogoHeader';
import Footer from '../Componentes/Footer';
import ImagemDiv from '../Componentes/ImagemDiv';
import { useNavigate, useParams } from 'react-router-dom';
import TextInput from '../Componentes/TextInput';
import { getDados, writeDados } from '../Funções/Conexão';
import Init from '../Funções/Init';
import BotaoDuplo from '../Componentes/BotaoDuplo';

function AcessoLink() {
  const [senha, setSenha] = useState('');
  const [senha2, setSenha2] = useState('');
  const [updatedPage, setUpdatedPage] = useState(false);
  const [erroLogin, setErroLogin] = useState(false);
  const [erroLoginTexto1, setErroLoginTexto1] = useState('');
  const [erroLoginTexto2, setErroLoginTexto2] = useState('');
  const { link } = useParams();

  useEffect(() => {
    if (!updatedPage) {
      checkLink();

      setUpdatedPage(true);
    }
  }, [updatedPage]);

  const checkLink = async () => {
    let st = await getDados(Init.url + 'checkLink', { link: link });
    if (st.auth == 0) {
      navigate('/');
    }
  };

  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        height: '100vh',
        minHeight: 720,
      }}
    >
      <div className="CorpoLogin">
        <div className="AreaLogin">
          <div className="AreaLoginInterna">
            <LogoHeader />

            <h3
              id="TituloLogin"
              style={{ textAlign: 'center', fontFamily: 'Montserrat', fontSize: 20 }}
            >
              LOGIN
            </h3>

            <p id="TextoDescritivo">Crie uma nova senha para acessar a plataforma</p>

            <TextInput
              titulo="Senha"
              tipo="password"
              password
              placeholder="Insira a senha"
              erro={erroLogin}
              erroTexto={erroLoginTexto1}
              onUpdate={(txt) => {
                setSenha(txt);
              }}
            />

            <TextInput
              titulo="Nova Senha"
              tipo="password"
              password
              placeholder="Insira a Senha"
              onUpdate={(txt) => setSenha2(txt)}
              erro={erroLogin}
              erroTexto={erroLoginTexto2}
            />

            <BotaoDuplo
              nome="Criar"
              externo
              clicadoVolta={() => navigate('/')}
              nomeVolta="Cancelar"
              clicado={() => {
                if (senha != '' && senha2 != '') {
                  if (senha == senha2) {
                    writeDados(Init.url + 'changePasswordByEmail', { senha: senha, link: link });
                    navigate('/');
                  } else {
                    setErroLoginTexto1('Senhas incompatíveis');
                    setErroLoginTexto2('Senhas incompatíveis');
                    setErroLogin(true);
                  }
                } else {
                  if (senha == '') {
                    setErroLoginTexto1('Preencha o campo');
                  }
                  if (senha2 == '') {
                    setErroLoginTexto2('Preencha o campo');
                  }

                  setErroLogin(true);
                }
              }}
            />

            <Footer />
          </div>
        </div>

        <ImagemDiv />
      </div>
    </div>
  );
}
export default AcessoLink;
